Object.defineProperty(exports,"__esModule",{value:true});exports.



updatePositionRuleState=updatePositionRuleState;exports.









updateFixtureRuleState=updateFixtureRuleState;exports.









updatePuckState=updatePuckState;exports.






updateProximityPuckState=updateProximityPuckState;exports.






updateFM20State=updateFM20State;exports.






updateCXFlexState=updateCXFlexState;exports.






updateNXDIPuckState=updateNXDIPuckState;exports.






updateSecurePlugState=updateSecurePlugState;exports.







updateRamState=updateRamState;exports.






updateLockState=updateLockState;exports.

















updateStore=updateStore;exports.


















updateStoreRule=updateStoreRule;exports.














updateSecurityDevice=updateSecurityDevice;exports.














updateFixtureRule=updateFixtureRule;exports.














updateFixture=updateFixture;exports.














updatePosition=updatePosition;exports.














updatePositionRule=updatePositionRule;exports.














updateRule=updateRule;exports.










updateProduct=updateProduct;exports.














updateSecuredProduct=updateSecuredProduct;exports.














updateSecurityDeviceHealthState=updateSecurityDeviceHealthState;exports.












updateAlarmModuleState=updateAlarmModuleState;exports.






updateKeyState=updateKeyState;var _MQTTActionTypes=require('./MQTTActionTypes');var _MQTTActionTypes2=_interopRequireDefault(_MQTTActionTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function updatePositionRuleState(_ref){var ruleId=_ref.ruleId,updatedAt=_ref.updatedAt;return{type:_MQTTActionTypes2.default.UPDATE_POSITION_RULE_STATE,payload:{ruleId:ruleId,updatedAt:updatedAt}};}function updateFixtureRuleState(_ref2){var ruleId=_ref2.ruleId,updatedAt=_ref2.updatedAt;return{type:_MQTTActionTypes2.default.UPDATE_FIXTURE_RULE_STATE,payload:{ruleId:ruleId,updatedAt:updatedAt}};}function updatePuckState(puckState){return{type:_MQTTActionTypes2.default.UPDATE_PUCK_STATE,payload:puckState};}function updateProximityPuckState(state){return{type:_MQTTActionTypes2.default.UPDATE_PROXIMITY_PUCK_STATE,payload:state};}function updateFM20State(state){return{type:_MQTTActionTypes2.default.UPDATE_FM20_STATE,payload:state};}function updateCXFlexState(cxFlexState){return{type:_MQTTActionTypes2.default.UPDATE_CX_FLEX_STATE,payload:cxFlexState};}function updateNXDIPuckState(NXDIPuckState){return{type:_MQTTActionTypes2.default.UPDATE_NXDI_PUCK_STATE,payload:NXDIPuckState};}function updateSecurePlugState(securePlugState){return{type:_MQTTActionTypes2.default.UPDATE_SECURE_PLUG_STATE,payload:securePlugState};}function updateRamState(parentDeviceState){return{type:_MQTTActionTypes2.default.UPDATE_RAM_STATE,payload:parentDeviceState};}function updateLockState(lockState){return{type:_MQTTActionTypes2.default.UPDATE_LOCK_STATE,payload:lockState};}function updateStore(storeId,action){return{type:_MQTTActionTypes2.default.UPDATE_STORE_INQUIRY,payload:{storeId:storeId,action:action}};}function updateStoreRule(storeRuleId,storeId,action){return{type:_MQTTActionTypes2.default.UPDATE_STORE_RULE_INQUIRY,payload:{storeRuleId:storeRuleId,storeId:storeId,action:action}};}function updateSecurityDevice(securityDeviceId,storeId,action){return{type:_MQTTActionTypes2.default.UPDATE_SECURITY_DEVICE_INQUIRY,payload:{securityDeviceId:securityDeviceId,storeId:storeId,action:action}};}function updateFixtureRule(fixtureRuleId,storeId,action){return{type:_MQTTActionTypes2.default.UPDATE_FIXTURE_RULE_INQUIRY,payload:{fixtureRuleId:fixtureRuleId,storeId:storeId,action:action}};}function updateFixture(fixtureId,storeId,action){return{type:_MQTTActionTypes2.default.UPDATE_FIXTURE_INQUIRY,payload:{fixtureId:fixtureId,storeId:storeId,action:action}};}function updatePosition(positionId,storeId,action){return{type:_MQTTActionTypes2.default.UPDATE_POSITION_INQUIRY,payload:{positionId:positionId,storeId:storeId,action:action}};}function updatePositionRule(positionRuleId,storeId,action){return{type:_MQTTActionTypes2.default.UPDATE_POSITION_RULE_INQUIRY,payload:{positionRuleId:positionRuleId,storeId:storeId,action:action}};}function updateRule(ruleId,storeId,action){return{type:_MQTTActionTypes2.default.UPDATE_RULE_INQUIRY,payload:{ruleId:ruleId,storeId:storeId,action:action}};}function updateProduct(productId,storeId,action){return{type:_MQTTActionTypes2.default.UPDATE_PRODUCT_INQUIRY,payload:{productId:productId,storeId:storeId,action:action}};}function updateSecuredProduct(securedProductId,storeId,action){return{type:_MQTTActionTypes2.default.UPDATE_SECURED_PRODUCT_INQUIRY,payload:{securedProductId:securedProductId,storeId:storeId,action:action}};}function updateSecurityDeviceHealthState(healthState,serialNumber){return{type:_MQTTActionTypes2.default.UPDATE_SECURITY_DEVICE_HEALTH_STATE,payload:{healthState:healthState,serialNumber:serialNumber}};}function updateAlarmModuleState(state){return{type:_MQTTActionTypes2.default.UPDATE_ALARM_MODULE_STATE,payload:state};}function updateKeyState(_ref3)



{var storeId=_ref3.storeId,keyCount=_ref3.keyCount,securityDeviceSerialNumber=_ref3.securityDeviceSerialNumber;
return{
type:_MQTTActionTypes2.default.UPDATE_KEY_STATE,
payload:{
storeId:storeId,
keyCount:keyCount,
securityDeviceSerialNumber:securityDeviceSerialNumber}};


}